import { render, staticRenderFns } from "./JoinedCompaigns.vue?vue&type=template&id=6ca5b37b&scoped=true"
import script from "./JoinedCompaigns.vue?vue&type=script&lang=js"
export * from "./JoinedCompaigns.vue?vue&type=script&lang=js"
import style0 from "./JoinedCompaigns.vue?vue&type=style&index=0&id=6ca5b37b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca5b37b",
  null
  
)

export default component.exports